import { Controller } from "@hotwired/stimulus"

const LARGE_SCREEN_MIN_WIDTH = "(min-width: 1024px)"

export default class extends Controller {
  static targets = ["slide", "indicator", "nextButton", "prevButton"]

  connect() {
    this.index = 0
    this.toggleIndicators()
  }

  move(event) {
    const oldIndex = this.index
    this.index += event.params.vector

    const minIndex = 0

    if (this.index < minIndex) {
      this.index = minIndex
    } else if (this.index >= this.slideTargets.length) {
      this.index = this.slideTargets.length
    }

    const inlineOption = this.index === 0 || this.index === this.slideTargets.length - 1 ? "nearest" : "center"

    this.slideTargets[this.index].scrollIntoView({ behavior: "smooth", block: "nearest", inline: inlineOption })
    this.nextButtonTarget.disabled = this.index >= this.slideTargets.length - 1
    this.prevButtonTarget.disabled = this.index <= minIndex

    if (oldIndex !== this.index) {
      this.toggleIndicators()
    }
  }
  toggleIndicators() {
    this.indicatorTargets.forEach((indicator, index) => {
      indicator.classList.toggle("bg-grey-600", index == this.index)
      indicator.classList.toggle("bg-grey-200", index != this.index)
    })
  }

  // isLargeScreen() {
  //   return window.matchMedia(LARGE_SCREEN_MIN_WIDTH).matches
  // }
}
